import React, { useState } from 'react';

import { useAuth, PageContext } from '@/src/app/hooks';
import { type LanguageOption } from '@/src/utils';

interface PageProviderProps {
    children: React.ReactNode;
}

export const PageProvider: React.FC<PageProviderProps> = ({ children }) => {
    const [subheaderTitle, setSubheaderTitle] = useState<string>('');
    const [subheaderType, setSubheaderType] = useState<'default' | 'hero'>('default');
    const [pageGrade, setPageGrade] = useState<string>(localStorage.getItem('pageGrade') || 'TK');
    const [pageUnit, setPageUnit] = useState<number>(
        tryParseInt(localStorage.getItem('pageUnit'), 1)
    );
    const [pageLesson, setPageLesson] = useState<number>(
        tryParseInt(localStorage.getItem('pageLesson'), 1)
    );
    const [pageLanguage, setPageLanguage] = useState<LanguageOption>(
        (localStorage.getItem('pageLanguage') as LanguageOption) || 'EN'
    );
    const [globalLoading, setGlobalLoading] = useState<boolean>(false);

    const { user } = useAuth();
    const userAllowedGrades = user?.allowedGrades
        ? [...user.allowedGrades.elementary, ...user.allowedGrades.middleSchool]
        : [];
    const validateGrade = (grade: string) => {
        return userAllowedGrades.includes(grade);
    };
    const setPageGradeWrapper = (grade: string) => {
        const validGrade = validateGrade(grade) ? grade : userAllowedGrades[0];
        setPageGrade(validGrade);
        localStorage.setItem('pageGrade', validGrade);
    };
    const setPageUnitWrapper = (unit: number) => {
        setPageUnit(unit);
        localStorage.setItem('pageUnit', unit.toString());
    };
    const setPageLessonWrapper = (lesson: number) => {
        setPageLesson(lesson);
        localStorage.setItem('pageLesson', lesson.toString());
    };
    const setPageLanguageWrapper = (language: LanguageOption) => {
        setPageLanguage(language);
        localStorage.setItem('pageLanguage', language);
    };

    return (
        <PageContext.Provider
            value={{
                subheaderTitle,
                setSubheaderTitle,
                subheaderType,
                setSubheaderType,
                pageGrade,
                setPageGrade: setPageGradeWrapper,
                validateGrade,
                pageUnit,
                setPageUnit: setPageUnitWrapper,
                pageLesson,
                setPageLesson: setPageLessonWrapper,
                pageLanguage,
                setPageLanguage: setPageLanguageWrapper,
                globalLoading,
                setGlobalLoading,
            }}
        >
            {children}
        </PageContext.Provider>
    );
};

function tryParseInt(value: string | null, defaultValue: number): number {
    if (value === null) return defaultValue;
    const parsed = parseInt(value);
    return isNaN(parsed) ? defaultValue : parsed;
}
